module.exports = __webpack_public_path__ + "static/BigBang_UAU_clip-4857e0892cf4e9ea0f2c633cdb4ad038.mp4";